import CashDrop from './CashDrop';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './CashDrop.state';

export default connect(mapStateToProps, mapDispatchToProps)(CashDrop);
